import { Grid } from "antd"

const { useBreakpoint } = Grid

export const useMobile = () => {
  const screens = useBreakpoint()

  const isMobile = !screens.md // true if screen < 768px
  const isTablet = screens.md && !screens.lg // true if 768px <= screen < 1024px
  const isDesktop = screens.lg // true if screen >= 1024px

  return {
    isMobile,
    isTablet,
    isDesktop,
  }
}

// Legacy exports for backward compatibility
export const useIsMobile = () => {
  const { isMobile } = useMobile()
  return isMobile
}

export const useIsTablet = () => {
  const { isTablet } = useMobile()
  return isTablet
}
